import { Menu, MenuItem, ListItemIcon, ListItemText, Divider } from "@mui/material";
import {
	DeleteOutline as DeleteOutlineIcon,
	HowToReg,
	PictureAsPdf as PictureAsPdfIcon,
	PostAdd as PostAddIcon,
	Sync,
	TableView as TableViewIcon,
	Visibility as VisibilityIcon,
	Assignment as AssignmentIcon,
} from "@mui/icons-material";

import { checkByProfileGuard } from "../../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../../shared/enums/profiles";

import { IInstallmentTable } from "../../types/types";

interface Props {
	anchorEl: HTMLElement | null;
	open: boolean;
	onClose: () => void;
	selectedRow: IInstallmentTable | null;
	onOpenModal: (type: "details" | "cancel" | "manual" | "convert" | "generate" | "launch", row: IInstallmentTable) => void;
	onExportPdf?: (row: IInstallmentTable) => void;
	onExportCsv?: (row: IInstallmentTable) => void;
}

export const InstallmentBilletMenu = ({ anchorEl, open, onClose, selectedRow, onOpenModal, onExportPdf, onExportCsv }: Props) => {
	const canLaunch = checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.Add);

	const handleClick = (type: "details" | "cancel" | "manual" | "convert" | "generate" | "launch") => {
		if (selectedRow) {
			onOpenModal(type, selectedRow);
			onClose();
		}
	};

	const handleExport = (action: "pdf" | "csv") => {
		if (!selectedRow) return;
		action === "pdf" ? onExportPdf?.(selectedRow) : onExportCsv?.(selectedRow);
		onClose();
	};

	return (
		<Menu anchorEl={anchorEl} open={open} onClose={onClose}>
			<MenuItem onClick={() => handleClick("details")}>
				<ListItemIcon>
					<VisibilityIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Visualizar Detalhes" />
			</MenuItem>
			<Divider />
			<MenuItem onClick={() => handleExport("pdf")}>
				<ListItemIcon>
					<PictureAsPdfIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Exportar PDF" />
			</MenuItem>

			<MenuItem onClick={() => handleExport("csv")}>
				<ListItemIcon>
					<TableViewIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Exportar CSV" />
			</MenuItem>
			<Divider />
			<MenuItem onClick={() => handleClick("cancel")}>
				<ListItemIcon>
					<DeleteOutlineIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Cancelar" />
			</MenuItem>

			<MenuItem onClick={() => handleClick("convert")}>
				<ListItemIcon>
					<Sync fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Converter Boleto → Cartão" />
			</MenuItem>

			<MenuItem onClick={() => handleClick("manual")}>
				<ListItemIcon>
					<HowToReg fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Baixar Manualmente" />
			</MenuItem>
			<MenuItem onClick={() => handleClick("launch")} disabled={!canLaunch}>
				<ListItemIcon>
					<PostAddIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText primary="Lançamento" />
			</MenuItem>
			<Divider />
			<MenuItem onClick={() => handleClick("generate")}>
				<ListItemIcon sx={{ color: "green" }}>
					<AssignmentIcon fontSize="small" />
				</ListItemIcon>
				<ListItemText sx={{ color: "green" }} primary="Faturar" />
			</MenuItem>
		</Menu>
	);
};
